<template>
  <div class="h-screen w-full flex flex-col">
    <div class="bg-gray-100 px-8 py-6 border-b border-solid border-gray-200">
      <div class="flex items-center justify-between">
        <div class="flex flex-col space-y-2">
          <h2 class="text-gray-800 text-xl font-poppins font-semibold">
            Genie Prompts ({{ app_genie_prompts.length }})
          </h2>
          <span class="font-poppins font-light">
            <i class="fa-solid fa-circle-exclamation text-red-500 mr-1.5"></i> Any sudden change can cause problems where the prompt is used! Be careful when using this feature.
          </span>
        </div>
        <button
          @click="handleGoOpenAIPlataform()"
          class="bg-blue-500 px-3 py-2 text-white"
        >
          Open AI Plataform
        </button>
      </div>
    </div>
    <div class="flex-grow h-full overflow-y-auto py-6 px-8">
      <ul class="flex flex-col space-y-3">
        <li
          v-for="(prompt, index) in app_genie_prompts"
          :key="index"
          @click="handleOpenPrompt(prompt)"
          class="bg-gray-50 border border-solid border-gray-200 px-4 py-3 flex text-pinky cursor-pointer items-center justify-between"
        >
          <div class="flex items-center space-x-3">
            <i class="fa-solid fa-wand-magic-sparkles"></i>
            <span class="hover:underline hover:text-pinky">
              {{ prompt.name }}
            </span>
          </div>
        </li>
      </ul>
    </div>
    <div class="flex justify-between items-center px-8 py-6">
      <button
        @click="$router.go(-1)"
        class="px-2 py-2 bg-gray-100 text-gray-700 border border-solid border-gray-200"
      >
        Back to Menu
      </button>
      <button></button>
    </div>
    <AdminGeniePrompts 
      v-if="is_genie_edit_prompt_modal_open === true"
      :name="selected_genie_prompt.name"
      :prompt_genie="selected_genie_prompt.prompt"
      :system_prompt="selected_genie_prompt.system_prompt"
      :user_prompt="selected_genie_prompt.user_prompt"
      :function_details="selected_genie_prompt.function_details"
      @close="is_genie_edit_prompt_modal_open = false" 
    />
  </div>
</template>
<script>
  import Axios from 'axios';
  import Vue from 'vue';
  import moment from 'moment';
  export default Vue.extend({
    data: () => ({
      app_genie_prompts: [],
      is_genie_edit_prompt_modal_open: false,
      selected_genie_prompt: {}
    }),
    components: {
      AdminGeniePrompts: () => import('./AdminGeniePrompts.vue')
    },
    methods: {
      handleOpenPrompt: async function (prompt) {
        const prompt_data = await Axios.get(`/api/genie_prompts/${prompt.name}`);
        this.is_genie_edit_prompt_modal_open = true;
        console.log(prompt_data, 'prompt_data');
        this.selected_genie_prompt = { name: prompt.name, prompt: prompt_data.data.content, system_prompt: prompt_data.data.system_prompt, user_prompt: prompt_data.data.user_prompt, function_details: prompt_data.data.function_details };
        console.log(this.selected_genie_prompt, 'selected');
        this.is_genie_edit_prompt_modal_open = true;
        return;
      },
      handleGoOpenAIPlataform: function () {
        window.open('https://platform.openai.com/account/usage', '_blank');
      },
      handleFormatedDate: function(date) {
        const date_formatted = moment(date).format('MMMM Do YYYY, h:mm:ss a');
        return date_formatted;
      }
    },
    mounted: async function() {
      const prompts = await Axios.get('/api/genie_prompts');
      this.app_genie_prompts = prompts.data;
    }
  });
</script>



// WEBPACK FOOTER //
// GeniePrompt.vue?33037251